export default "__VITE_ASSET__Cot5uinM__"